import {Avatar, Badge, Box, Drawer, IconButton, ListItem, Stack, Tooltip, Typography} from "@mui/joy";
import {useSessionCookie} from "../../hooks/useSessionCookie";
import {appRoute} from "../../utils/routes";
import React, {useState} from "react";
import {SideBarContent} from "./SideBar";
import {useNavigationTitle} from "../../hooks/useNavigationTitle";
import {BellIcon, CogIcon, MenuIcon, UserCog, UserCog2, UserIcon} from "lucide-react";
import {BottomNavbarContent} from "./BottomNavbar";
import {useUITheme} from "../../hooks/useUITheme";
import {Link, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {User} from "../../models/user";
import Logo from "../Logo";
import FullLogo from "../FullLogo";
import {useNotification} from "../../hooks/useNotification";

const NavBar = () => {
    const uiTheme = useUITheme()
    const {userSession} = useSessionCookie()
    const user: User | undefined = userSession?.['currentUser']
    const location = useLocation()
    const {badgeCount} = useNotification()

    return <Box height={"max-content"} width={"100%"} paddingX={3} paddingY={0.5} gap={2}
                justifyContent={"flex-end"}
                boxSizing={"border-box"} display={{xs: "flex", md: "none"}}
        // display={{md: "flex", xs: "none"}}
                sx={{
                    backdropFilter: uiTheme.sideBarProps.backdropFilter,
                    border: uiTheme.sideBarProps.border,
                    backgroundColor: uiTheme.sideBarProps.backgroundColor,
                }}>

        <Stack direction={"row"} width={"100%"} justifyContent={"space-between"} alignItems={"center"}>

            <Link to={appRoute()} style={{textDecoration: "none", width: "max-content"}}>
                <FullLogo/>
            </Link>

            <Stack gap={2} direction={"row"} alignItems={"center"}>

                <Link to={appRoute("notifications")} style={{textDecoration: "none"}}>
                    <ListItem data-selected={location.pathname === appRoute("notifications")}
                              sx={{
                                  width: "100%",
                                  borderRadius: 15,
                                  justifyContent: "center",
                              }}>
                        <Stack alignItems={"center"} gap={1}>
                            <Badge badgeContent={badgeCount}>
                                <BellIcon style={{fontSize: 24}}/>
                            </Badge>
                        </Stack>
                    </ListItem>
                </Link>

                <Link to={appRoute("settings")} style={{textDecoration: "none"}}>
                    <ListItem data-selected={location.pathname === appRoute("settings")}
                              sx={{
                                  width: "100%",
                                  borderRadius: 15,
                                  justifyContent: "center",
                              }}>
                        <Stack alignItems={"center"} gap={1}>
                            <Avatar color={"primary"} sx={{fontWeight:"bold"}}>
                                {user?.name?.split(" ")[0].substring(0, 1)}{user?.name?.split(" ")[1]?.substring(0, 1)}
                            </Avatar>
                        </Stack>

                    </ListItem>
                </Link>
            </Stack>


        </Stack>

    </Box>


}

export default NavBar